import "./ModelService";

import {
  AssociateDatasetButton,
  ModelAddNewVersionButton,
  ModelDeleteButton,
  SyncRemoteModelButton,
  UpdateRemoteUrlButton,
} from "./ModelButtons";
import RemoteModelSyncSettings from "./components/RemoteModelSyncSettings";
import { AssociateDatasetForm, RQModelVersionsList } from "./Models";
import {
  CButton,
  CCard,
  CCardBody,
  CCardFooter,
  CCardHeader,
  CCol,
  CContainer,
  CInput,
  CLink,
  CPopover,
  CRow,
  CTextarea,
} from "@coreui/react";
import { Can, usePermission } from "src/helpers/Auth";

import {
  ModelService,
  useDeleteModelDatasetAssociation,
  useGetAllModelTags,
  useGetModel,
  useModelDatasets,
} from "./ModelService";
import React, { useEffect, useRef, useState } from "react";
import { useQueryClient } from "react-query";

import CIcon from "@coreui/icons-react";
import ModelStatus from "./ModelStatus";
import { isAgentBindable } from "src/reusable/components/ModelComboSelect";
import { ProjectAIProductID } from "src/reusable/products";
import PropTypes from "prop-types";
// react-polling is unmaintained upstream; replace when this view is next reworked.
import ReactPolling from "react-polling";
import { Checkbox, FormControlLabel, Stack, Typography } from "@mui/material";
import Table from "react-bootstrap/Table";
import TagSelect from "src/reusable/components/select/tag-select";
import { determineLoginPlatformType } from "src/reusable/Functions";
import { useDatasetFields } from "../datasets/services/DatasetServices";

class ModelWorkflow extends React.Component {
  constructor(props) {
    super(props);
    this.textDivStyle = { textAlign: "center", fontSize: "75%" };
    this.lineDivStyle = {
      //width: "25px",
      height: "31px",
      borderBottom: "1px solid #585858",
      //marginRight: "-10px",
      //marginLeft: "-10px"
    };
    this.completedStyle = {
      border: "1px solid #1F821D",
      background: "#81DA7F",
      width: "30px",
      height: "30px",
      textAlign: "center",
      borderRadius: "50%",
      fontSize: "20px",
      lineHeight: "25px",
      display: "inline-block",
    };
    this.inprogressStyle = { ...this.completedStyle };
    this.notstartedStyle = { ...this.completedStyle };
    delete this.notstartedStyle.background;
  }

  render() {
    var inputDivStyle = this.notstartedStyle;
    var inputText = "";
    var modelDivStyle = this.notstartedStyle;
    var modelText = "";
    var trainDivStyle = this.notstartedStyle;
    var trainText = "";
    var deployDivStyle = this.notstartedStyle;
    var deployText = "";
    if (["inputs"].includes(this.props.status)) {
      inputDivStyle = this.inprogressStyle;
    } else if (["model"].includes(this.props.status)) {
      inputDivStyle = this.completedStyle;
      inputText = "✓";
      modelDivStyle = this.inprogressStyle;
    } else if (["training", "not_trained"].includes(this.props.status)) {
      inputDivStyle = this.completedStyle;
      inputText = "✓";
      modelDivStyle = this.completedStyle;
      modelText = "✓";
      trainDivStyle = this.inprogressStyle;
    } else if (["trained"].includes(this.props.status)) {
      inputDivStyle = this.completedStyle;
      inputText = "✓";
      modelDivStyle = this.completedStyle;
      modelText = "✓";
      trainDivStyle = this.completedStyle;
      trainText = "✓";
      deployDivStyle = this.inprogressStyle;
    } else if (["deployed"].includes(this.props.status)) {
      inputDivStyle = this.completedStyle;
      inputText = "✓";
      modelDivStyle = this.completedStyle;
      modelText = "✓";
      trainDivStyle = this.completedStyle;
      trainText = "✓";
      deployDivStyle = this.completedStyle;
      deployText = "✓";
    }
    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <CCol sm="1" style={this.textDivStyle}>
          Inputs
          <br />
          <div style={inputDivStyle}>{inputText}</div>
        </CCol>
        <CCol sm="1" style={this.lineDivStyle}></CCol>
        <CCol sm="1" style={this.textDivStyle}>
          Model
          <br />
          <div style={modelDivStyle}>{modelText}</div>
        </CCol>
        <CCol sm="1" style={this.lineDivStyle}></CCol>
        <CCol sm="1" style={this.textDivStyle}>
          Train
          <br />
          <div style={trainDivStyle}>{trainText}</div>
        </CCol>
        <CCol sm="1" style={this.lineDivStyle}></CCol>
        <CCol sm="1" style={this.textDivStyle}>
          Deploy
          <br />
          <div style={deployDivStyle}>{deployText}</div>
        </CCol>
      </div>
    );
  }
}

function UseModelDatasetsOverride(props) {
  // let the function
  return props.children(useModelDatasets(props.model_id));
}

const DatasetRow = ({ dataset, modelId }) => {
  const { data, isLoading } = useDatasetFields(dataset.id);
  const deleteModelDatasetAssociation = useDeleteModelDatasetAssociation();
  const { data: model } = useGetModel(modelId);
  return (
    <tr>
      <td>
        <CLink
          to={`/datasets/${dataset.id}/viewer`}
          data-attr={`models:link:view-dataset-${dataset.id}`}
        >
          {dataset.name}{" "}
        </CLink>
      </td>
      <td>{dataset.description}</td>
      <td>
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          {!isLoading &&
            data
              .sort((x, y) => {
                if (x.field_name < y.field_name) {
                  return -1;
                }
                if (x.field_name > y.field_name) {
                  return 1;
                } else {
                  return 0;
                }
              })
              .map((d, idx) => (
                <div
                  key={idx}
                  style={{
                    width: "fitcontent",
                    margin: "0.5em",
                    border: "1px solid gray",
                    borderRadius: "5px",
                    padding: "1px 3px 1px 3px",
                    background: "lightgray",
                  }}
                  id={d.field_name}
                >
                  <CPopover
                    header={`${d?.field_name} Description`}
                    content={d.description}
                  >
                    <span>{d.field_name}</span>
                  </CPopover>
                </div>
              ))}
        </div>
      </td>
      <td>
        <CButton
          data-testid={`mdl-btn-delete-dataset-${dataset.id}`}
          data-attr={`models:btn:remove-dataset-${dataset.id}`}
          className="delete-dataset-button"
          color="danger"
          size="sm"
          style={{ marginLeft: "5px" }}
          onClick={() =>
            deleteModelDatasetAssociation.mutate({
              modelId: modelId,
              datasetId: dataset.id,
            })
          }
          disabled={
            !usePermission("model:delete").canIt ||
            model?.model_products[0]?.products?.id === ProjectAIProductID
          }
        >
          <CIcon name="cil-trash" />
        </CButton>
      </td>
    </tr>
  );
};

DatasetRow.propTypes = {
  dataset: PropTypes.object.isRequired,
  modelId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export const ModelDatasets = ({ model_id }) => {
  return (
    <>
      <UseModelDatasetsOverride model_id={model_id}>
        {({ data, isLoading }) => {
          return !isLoading ? (
            data.length > 0 ? (
              <>
                <Table
                  data-testid="mdl-table-datasets"
                  style={{ width: "fixed" }}
                >
                  <thead>
                    <tr>
                      <td style={{ width: "10%" }}>Name</td>
                      <td style={{ width: "20%" }}>Description</td>
                      <td style={{ width: "60%" }}>Data Fields</td>
                      <td style={{ width: "10%" }}>Actions</td>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((dataset, idx) => {
                      return (
                        <DatasetRow
                          key={idx}
                          dataset={dataset}
                          modelId={model_id}
                        />
                      );
                    })}
                  </tbody>
                </Table>
              </>
            ) : (
              <div style={{ margin: ".75em" }}>No Datasets Associated.</div>
            )
          ) : (
            <>Loading...</>
          );
        }}
      </UseModelDatasetsOverride>
    </>
  );
};

ModelDatasets.propTypes = {
  model_id: PropTypes.number.isRequired,
};

ModelWorkflow.propTypes = {
  status: PropTypes.string.isRequired,
};

const ModelDetails = (props) => {
  const { match } = props;
  const modelId = match.params.model_id;
  const [ready, setReady] = useState(false);
  const [model, setModel] = useState(null);
  const [selectedTags, setSelectedTags] = useState([]);
  const [availableTags, setAvailableTags] = useState([]);
  const queryClient = useQueryClient();

  // Use a ref to always have the latest model state in delayed callbacks
  const modelRef = useRef(model);
  useEffect(() => {
    modelRef.current = model;
    if (model !== null && model !== undefined) {
      setSelectedTags(model.tags);
    }
  }, [model]);

  const loadModel = () => {
    ModelService.get_model(
      modelId,
      (data) => {
        setModel(data);
        setReady(true);
      },
      (error) => {
        console.log(error);
      },
    );
  };

  const { data: modelTags, isSuccess: isModelTagsSuccess } =
    useGetAllModelTags();

  useEffect(() => {
    if (isModelTagsSuccess && modelTags) {
      setAvailableTags(modelTags.map((tag) => tag.tag));
    }
  }, [isModelTagsSuccess, modelTags]);

  // Load the model when the component mounts or when modelId changes
  useEffect(() => {
    loadModel();
  }, [modelId]);

  const updateModelName = (e) => {
    const newName = e.target.value;
    setModel((prevModel) => ({
      ...prevModel,
      name: newName,
    }));
    const cur_name = newName;
    setTimeout(() => {
      if (modelRef.current && modelRef.current.name === cur_name) {
        ModelService.update_model_attribute(modelId, "name", cur_name);
      }
    }, 2000);
  };

  // Saved immediately rather than on the 2s debounce the text fields use, since a
  // checkbox has no "still typing" state to wait out.
  const updateModelAgentBindable = (e) => {
    const newValue = e.target.checked;
    setModel((prevModel) => ({
      ...prevModel,
      agent_bindable: newValue,
    }));
    ModelService.update_model_attribute(modelId, "agent_bindable", newValue)
      .then(() => queryClient.invalidateQueries("getModels"))
      .catch((error) => {
        console.log(error);
        setModel((prevModel) => ({
          ...prevModel,
          agent_bindable: !newValue,
        }));
      });
  };

  const updateModelTags = (newTags) => {
    setModel((prevModel) => ({
      ...prevModel,
      tags: newTags,
    }));
    const currentTags = newTags;
    setTimeout(() => {
      if (modelRef.current && modelRef.current.tags === currentTags) {
        ModelService.update_model_attribute(modelId, "tags", currentTags);
      }
    }, 2000);
  };

  const updateModelDescription = (e) => {
    const newDescription = e.target.value;
    setModel((prevModel) => ({
      ...prevModel,
      description: newDescription,
    }));
    const cur_description = newDescription;
    setTimeout(() => {
      if (
        modelRef.current &&
        modelRef.current.description === cur_description
      ) {
        ModelService.update_model_attribute(
          modelId,
          "description",
          cur_description,
        );
      }
    }, 2000);
  };

  if (!ready) {
    return <>Loading</>;
  }

  return (
    <ReactPolling
      url={"url to poll"}
      interval={30000}
      retryCount={3}
      onSuccess={(response) => {
        // Don't overwrite locally-edited fields with the polled copy.
        let currentModel = model;
        const model_name = currentModel.name;
        const model_description = currentModel.description;
        const model_agent_bindable = currentModel.agent_bindable;
        currentModel = response.data;
        currentModel.name = model_name;
        currentModel.description = model_description;
        currentModel.agent_bindable = model_agent_bindable;
        setModel(currentModel);
        return true;
      }}
      onFailure={(e) => {
        console.log(e);
        return true;
      }}
      promise={() => ModelService.get_model_promise(model.id)}
      // eslint-disable-next-line
      render={({ startPolling, stopPolling, isPolling }) => {
        return (
          <>
            <div
              style={{
                textAlign: "center",
                color: "#676767",
                marginBottom: "1.5em",
                marginTop: "1%",
              }}
            >
              <h1 data-testid="mdl-title">{model.name}</h1>
              {model.description}
            </div>

            <Can
              perform="model:update"
              yes={() => (
                <CCard
                  data-testid="mdl-card-info-editor"
                  style={{ margin: ".75em" }}
                >
                  <CCardHeader>
                    <h3>Model Info Editor</h3>
                  </CCardHeader>
                  <CCardBody>
                    <CContainer>
                      <CRow>
                        <CCol md="5" style={{ padding: "10px" }}>
                          <CRow>
                            <CInput
                              data-testid="mdl-input-name"
                              data-attr="models:input:edit-model-name"
                              placeholder="Text"
                              value={model.name}
                              onChange={updateModelName}
                              style={{
                                background: "#F8F8F8",
                                color: "#555555",
                                fontWeight: "bold",
                                textAlign: "center",
                                fontSize: "large",
                              }}
                            />
                          </CRow>
                          <CRow style={{ textAlign: "center", marginTop: "" }}>
                            <ModelStatus
                              data-testid="mdl-status"
                              style={{
                                alignContent: "center",
                                margin: ".75em",
                              }}
                              model={model}
                            />
                          </CRow>
                        </CCol>

                        <CCol
                          md="7"
                          style={{
                            alignContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <CTextarea
                            data-testid="mdl-input-description"
                            data-attr="models:input:edit-model-description"
                            name="textarea-input"
                            id="textarea-input"
                            rows="4"
                            placeholder="Model description"
                            value={model.description}
                            onChange={updateModelDescription}
                          />
                        </CCol>
                      </CRow>
                      <CRow style={{ padding: "10px" }}>
                        <CCol md="5" style={{ padding: "10px" }}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                data-testid="mdl-checkbox-agent-bindable"
                                data-attr="models:checkbox:edit-model-agent-bindable"
                                checked={isAgentBindable(model)}
                                onChange={updateModelAgentBindable}
                              />
                            }
                            label={
                              <span>
                                <Typography variant="body2" fontWeight={500}>
                                  Available to agents
                                </Typography>
                                <Typography
                                  variant="caption"
                                  color="text.secondary"
                                >
                                  Offer this model when choosing a model for an
                                  agent. Agents already using it keep working
                                  either way.
                                </Typography>
                              </span>
                            }
                            sx={{ alignItems: "flex-start", m: 0 }}
                          />
                        </CCol>
                        <CCol
                          md="7"
                          style={{
                            alignContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <TagSelect
                            data-testid="mdl-select-tags"
                            data-attr="models:select:edit-model-tags"
                            value={selectedTags}
                            onChange={(newTags) => {
                              updateModelTags(newTags);
                            }}
                            availableTags={availableTags}
                            setAvailableTags={setAvailableTags}
                            placeholder="Tags for model"
                            allowCreation={true}
                            isSmText={true}
                          />
                        </CCol>
                      </CRow>
                    </CContainer>
                  </CCardBody>
                </CCard>
              )}
              no={() => <p>{model.description}</p>}
            />

            <CCard
              data-testid="mdl-workflow"
              style={{
                margin: ".75em",
                padding: ".75em",
                textAlign: "center",
              }}
            >
              <ModelWorkflow status={model.versions[0]?.status_fk} />
            </CCard>
            <Can
              perform="model:update"
              yes={() => {
                return (
                  <CRow>
                    <CCol>
                      <CCard
                        data-testid="mdl-card-datasets"
                        style={{ margin: ".75em" }}
                      >
                        <CCardHeader>
                          <h3>Associated Datasets</h3>
                        </CCardHeader>
                        <div style={{ padding: "1em" }}>
                          A list of datasets associated to {model.name}. Score
                          these datasets using the {model.name}, and eventually
                          train new model versions!{" "}
                          <p>
                            Ensure that you can match up a dataset field with
                            the necessary model input fields!
                          </p>
                        </div>
                        <ModelDatasets model_id={model.id} />
                        <CCardFooter>
                          <Stack direction="row">
                            <AssociateDatasetButton
                              disabled={
                                model?.model_products[0]?.products?.id ===
                                ProjectAIProductID
                              }
                              hideIcon
                              executecontents={"Associate New Dataset"}
                              modaltitle={"Associate New Dataset"}
                              sx={{ flexGrow: 1 }}
                            >
                              <AssociateDatasetForm model_id={model.id} />
                            </AssociateDatasetButton>
                          </Stack>
                        </CCardFooter>
                      </CCard>
                      {model.remote_model && (
                        <div style={{ margin: ".75em" }}>
                          <RemoteModelSyncSettings modelId={model.id} />
                        </div>
                      )}
                      <CCard
                        data-testid="mdl-card-versions"
                        style={{ margin: ".75em" }}
                      >
                        <CCardHeader>
                          <CRow>
                            <CCol xs="9">
                              <div style={{ marginBottom: "1em" }}>
                                <h3>{model.name} Model Versions</h3>
                              </div>
                            </CCol>
                            <CCol xs="3" style={{ textAlign: "right" }}>
                              {model.remote_model ? (
                                <Stack
                                  direction="row"
                                  spacing={1}
                                  justifyContent="flex-end"
                                >
                                  <UpdateRemoteUrlButton
                                    modelId={model.id}
                                    onSuccess={loadModel}
                                  />
                                  <SyncRemoteModelButton modelId={model.id} />
                                </Stack>
                              ) : (
                                <ModelAddNewVersionButton
                                  modelId={model.id}
                                  readyModel={model.ready_model}
                                />
                              )}
                            </CCol>
                          </CRow>
                        </CCardHeader>
                        <div style={{ padding: "1em" }}>
                          {`Each Model in ${determineLoginPlatformType()} can be versioned. Versioned
                            models have their own specific dataset inputs,
                            specific associated datasets, and input field pairs.
                            Versions help us experiment with new model and
                            dataset combinations while making sure we can always
                            keep seperate versions running properly!`}
                        </div>
                        <div style={{ margin: ".75em" }}>
                          <RQModelVersionsList
                            modelId={model.id}
                            refreshParent={loadModel}
                          />
                        </div>
                      </CCard>
                    </CCol>
                  </CRow>
                );
              }}
            />
            <Can
              perform="model:delete"
              yes={() => (
                <CCard
                  data-testid="mdl-card-management"
                  style={{ margin: ".75em" }}
                >
                  <CCardHeader>
                    <h3>Model Management</h3>
                  </CCardHeader>
                  <CCardBody>
                    {`Careful! Functions in this area can break ${determineLoginPlatformType()}.`}
                    <p></p>
                    <ModelDeleteButton
                      modelId={model.id}
                      modelName={model.name}
                      modelType={model.model_products?.[0]?.products?.name}
                    />
                  </CCardBody>
                </CCard>
              )}
            />
          </>
        );
      }}
    ></ReactPolling>
  );
};

ModelDetails.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      model_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
    }).isRequired,
  }).isRequired,
};

ModelDetails.defaultProps = {
  // A default match object is provided for cases where routing isn't available,
  // though in production this should be supplied by your routing mechanism.
  match: {
    params: {
      model_id: "",
    },
  },
};

export default ModelDetails;
